import React from 'react'
import { CardHeader, Heading, Text, Flex, Image } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { usePriceCakeBusd } from 'state/farms/hooks'


const Wrapper = styled(CardHeader)<{ isFinished?: boolean; background?: string }>`
  background: ${({ isFinished, background, theme }) =>
    isFinished ? theme.colors.backgroundDisabled : theme.colors.gradients[background]};
  border-radius: ${({ theme }) => `${theme.radii.card} ${theme.radii.card} 0 0`};
    background: #ffffff00;
  `

const StyledCardHeader: React.FC<{
  earningTokenSymbol: string
  stakingTokenSymbol: string
  isAutoVault?: boolean
  isFinished?: boolean
  isStaking?: boolean
  number: string
}> = ({ earningTokenSymbol, stakingTokenSymbol, number, isFinished = false, isAutoVault = false, isStaking = false }) => {
  const { t } = useTranslation()
  const poolImageSrc = isAutoVault
    ? `00.png`
    : `${number}.png`.toLocaleLowerCase()
  const isCakePool = earningTokenSymbol === 'CAKE' && stakingTokenSymbol === 'CAKE'
  const background = isStaking ? 'bubblegum' : 'cardHeader'
  const price = usePriceCakeBusd()
  const price1 = price.toNumber()
  const discountpercent = price1 / 100
  const discountpercent2 = 0.005714 /  discountpercent
  const discountpercent3 = 100 - discountpercent2
  const discountpercent4 = discountpercent3.toFixed(2)

  const getHeadingPrefix = () => {
    if (isAutoVault) {
      // vault
      return t('Auto')
    }
    if (isCakePool) {
      // manual cake
      return t('Manual')
    }
    // all other pools
    return t('Buy')
  }



  return (
    <Wrapper isFinished={isFinished} background={background}>
    <Flex alignItems="center" justifyContent="space-between">
      <Flex flexDirection="column">
        <Heading color={isFinished ? 'textDisabled' : 'body'} scale="lg">
          {`${getHeadingPrefix()} ${earningTokenSymbol}`}
        </Heading>
        <Flex alignItems="left" mt="5px" justifyContent="left">
        <Text textAlign="left" fontSize="20px"  mr="5px"  color='gold'>   
          {t('With a discount')}
          </Text>
          <Image src="/images/pixel/PoolIcon2.png" width={28} height={28} />
          </Flex>
    </Flex>
      <Image src={`/images/pools/${poolImageSrc}`} alt={number} width={85} height={85} />
    </Flex>
  </Wrapper>
  )
}

export default StyledCardHeader
